import AutoplayController from "~/lib/autoplay_controller"
import { money, replay } from "~/lib/motion"

// The cursor fills the box; once it's full the discount unlocks
export default class extends AutoplayController {
  static targets = ["item", "bar", "count", "price", "foot"]
  static values = { picks: Array, discount: Number }

  reset() {
    this.itemTargets.forEach((item) => item.classList.remove("is-picked"))
    this.barTarget.style.width = "0"
    this.countTarget.textContent = `0 / ${this.picksValue.length} picked`
    this.priceTarget.textContent = money(0)
  }

  async play(wait) {
    const size = this.picksValue.length
    let sum = 0
    for (const [n, index] of this.picksValue.entries()) {
      const item = this.itemTargets[index]
      await wait(350)
      await this.click(item, wait)
      item.classList.add("is-picked")
      sum += Number(item.dataset.price)
      this.barTarget.style.width = ((n + 1) / size) * 100 + "%"
      this.countTarget.textContent = `${n + 1} / ${size} picked`
      this.priceTarget.textContent = money(sum)
    }
    await wait(500)
    this.countTarget.textContent = `${Math.round(this.discountValue * 100)}% off unlocked`
    this.priceTarget.innerHTML = `<s>${money(sum)}</s>${money(sum * (1 - this.discountValue))}`
    replay(this.footTarget, "is-flash")
  }
}
